import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import XenditAPI from "../api/XenditAPI";

const PaymentStatusPage = () => {
    const navigate = useNavigate();
    const { refNo, status } = useParams();

    useEffect(() => {
        const validStatus = ['success', 'failed', 'pending'];
        if (!validStatus.includes(status)) navigate('/');

        const redirect = async () => {
            const res = await XenditAPI.redirect({ refNo, status })
            window.location.href = res.redirectUrl
        }
        redirect()
    }, [])

    return (
        <div className="payment-status">
            <div className="page-wrapper">
                <h3>Loading...</h3>
                <p className="warning">Please do not close the app while the transaction is processing</p>
                <p>Payment <b className={status}>{status}</b>. Redirecting to payment status page.</p>
            </div>
        </div>
    )
}

export default PaymentStatusPage
